export default __webpack_public_path__ + "static/media/chick-fil-a.e5630b5b.svg";